<template>
  <div :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
<!--       <a class="simple-text logo-mini"
         href="https://inmobito.app">
          <div class="logo-img"> -->
            <div class="text-center logo-normal">
              <a class="show-hide-menu" @click.prevent="minimizeSidebar">
                <i :class="$sidebar.isMinimized ? 'ti-menu' : 'ti-menu'"></i>
              </a>
              <a href="/"><img :src="logo" alt=""></a>
            </div>
            <div class="logo-mini">
              <!-- <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
                <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
              </button> -->
            </div>
          <!-- </div>
      </a> -->
    <!--   <a class="simple-text logo-normal"
         href="https://inmobito.app">
          {{ title }}
      </a> -->
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link"
                        :ref="link.session !== undefined ? link.session : ''">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

        <li class="logout-link">
          <a href="/logout" @click.prevent="logout" class=""><i class="icon-menu icon-menu-logout"></i> <p>Logout</p></a>
        </li>

      </ul>
    </div>
    <div class="alert-box-wrap">
      <div class="alert-box" v-if="newOrdersCount > 0" @click="goToOrders('NEW')">
        <i class=""></i>
        <span class="number">{{ newOrdersCount }} {{ $t('ordersStatus.NEW')}}</span>
      </div>
      <div class="alert-box processing" v-if="processingOrdersCount > 0" @click="goToOrders('PROCESSING')">
        <i class=""></i>
        <span class="number">{{ processingOrdersCount }} {{ $t('ordersStatus.PROCESSING')}}</span>
      </div>
    </div>
    <audio src="/static/audio/alarm.mp3" muted ></audio>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: 'tapTasty'
      },
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/logo-sm.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    created () {
      this.minimizeSidebar()
      this.$nextTick(() => {
        this.startPlaySound()
      })
    },
    data () {
      return {
        children: [],
        collapsed: true,
        heartbeatSet: false,
        newOrdersCount: 0,
        processingOrdersCount: 0,
        audioFile: null,
        audioPlayed: true
      }
    },
    computed: {
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      },
      heartbeat: function () {
        var self = this

        setInterval(() => {
          // refresh value set in OrderView.Vue when a status is updated
          if (this.$session.get('refreshOrdersCount') === 'refresh') {
            this.$session.set('refreshOrdersCount', '')
            self.getCounter()
          }
        }, 1000 * 2)

        setInterval(() => {
          self.getCounter()
        }, 1000 * 15)

        this.loadSound()
        if ((self.newOrdersCount > 0 || self.processingOrdersCount > 0) && this.$session.exists()) {
          self.playSound()
        }

        setInterval(() => {
          this.loadSound()
          if ((self.newOrdersCount > 0 || self.processingOrdersCount > 0) && this.$session.exists()) {
            self.playSound()
          }
        }, 1000 * 3)
      },
      loadSound () {
        console.warn('audio load')
        let sound = document.querySelector('audio')
        if (sound) {
          sound.volume = 0
        }
        // sound.play()
      },
      playSound () {
        console.warn('audio play')
        let sound = document.querySelector('audio')
        if (sound) {
          sound.volume = 1
          sound.play()
        }
      },
      startPlaySound () {
        let sound = document.querySelector('audio')
        sound.volume = 1
        // sound.play()
      },
      getCounter () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          status: 'NEW',
          seen: 0
        }
        var filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          data.location_ids = filterCookie.join(',')
        }
        var self = this
        this.apiRequest('/counters', 'GET', data, function (response) {
          var newFeedback = false
          var newOrders = false
          var processingOrders = false
          if (response.status === true) {
            // new orders
            if (response.data['orders'] > 0) {
              newOrders = true
              self.newOrdersCount = response.data['orders']
            } else {
              self.newOrdersCount = 0
            }
            self.$session.set('newOrders', newOrders)
            // provessing orders
            if (response.data['orders_processing'] > 0) {
              processingOrders = true
              self.processingOrdersCount = response.data['orders_processing']
            } else {
              self.processingOrdersCount = 0
            }
            self.$session.set('processingOrders', processingOrders)
            // feedback
            if (response.data['feedbacks'] > 0) {
              newFeedback = true
            }
            self.$session.set('newFeedback', true)
          }
          if (self.$refs.newFeedback[0] !== undefined) {
            if (newFeedback) {
              self.$refs.newFeedback[0].$el.classList.add('alert-menu')
            } else {
              self.$refs.newFeedback[0].$el.classList.remove('alert-menu')
            }
          }
          if (self.$refs.newOrders[0] !== undefined) {
            if (newOrders || processingOrders) {
              self.$refs.newOrders[0].$el.classList.add('alert-menu')
            } else {
              self.$refs.newOrders[0].$el.classList.remove('alert-menu')
            }
          }
        })
      },
      goToOrders (status) {
        this.$session.set('temp-status', status)
        this.$nextTick(function () {
          console.warn(this.$router)
          this.$router.replace('/orders')
        })
      }
    },
    mounted () {
      if (!this.heartbeatSet) {
        this.getCounter()
        this.heartbeat()
        this.heartbeatSet = true
        // this.audioFile = new Audio('/static/audio/alarm.mp3')
      }

      this.initScrollBarAsync()
      var newFeedback = this.$session.get('newFeedback')
      if (this.$refs.newFeedback[0] !== undefined) {
        if (newFeedback) {
          this.$refs.newFeedback[0].$el.classList.add('alert-menu')
        }
      }
      var newOrders = this.$session.get('newOrders')
      if (this.$refs.newOrders[0] !== undefined) {
        if (newOrders) {
          this.$refs.newOrders[0].$el.classList.add('alert-menu')
        }
      }
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 200px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue